import React from 'react'
import { useLocation } from 'react-router-dom'
import { Typography, Box, Container, useTheme } from '@mui/material'
import QRCode from 'react-qr-code'
import PageHeader from '../../components/PageHeader'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import {
  ControlsBox,
  StatusCircle,
  SectionTitleTypography,
  InstructionTypography,
  InstructionBox,
  QrCodeBox,
  QrCodeSectionBox,
  QrCodeTitle,
  QrCodeDescription,
  FooterTypography
} from './styled'

const QrcodeFeature = (): JSX.Element => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const theme = useTheme()

  const sectionId = queryParams.get('sectionId')?.trim() ?? 'Unknown ID'
  const sectionTitle = queryParams.get('sectionTitle')?.trim() ?? 'Unknown Title'
  const slotNodeStatus = queryParams.get('slotNodeStatus')?.trim() ?? 'Unknown Status'
  const distributionSeriesId = queryParams.get('distributionSeriesId')?.trim() ?? 'distributionSeriesId'
  const baseURL = window.location.origin

  return (
    <>
      <CustomHeader title={`${sectionId} | ${PAGE_TITLES.QRCODE}` as PAGE_TITLES} />

      <PageHeader
        title="Survey In Progress"
        showBackButton
        isCompactOnly
        controls={
          <ControlsBox status={slotNodeStatus.toUpperCase()}>
            <StatusCircle status={slotNodeStatus.toUpperCase()} />
            <Typography sx={{ fontSize: '16px', fontWeight: '600', lineHeight: theme.spacing(6) }}>
              {slotNodeStatus.toUpperCase()}
            </Typography>
          </ControlsBox>
        }
      />

      <Container sx={{ display: 'flex', gap: 9 }}>
        <InstructionBox>
          <SectionTitleTypography>
            Login Instructions for: {sectionId} - {sectionTitle}
          </SectionTitleTypography>

          <InstructionTypography marginBottom={'22px'} gutterBottom>
            To access your survey:
          </InstructionTypography>

          <Box component="ol" sx={{ paddingLeft: 7 }}>
            <InstructionTypography as="li">Scan the QR code here →</InstructionTypography>
            <InstructionTypography as="li">
              To login, follow the instructions sent to your school email.
              <Box sx={{ paddingLeft: 0, marginTop: 0.5 }}>
                <InstructionTypography sx={{
                  textIndent: theme.spacing(-6),
                  paddingLeft: theme.spacing(6)
                }} >
                  a. This should be from an email ending in{' '}
                </InstructionTypography>

                <Typography component="p" fontWeight={500} fontStyle="italic" fontSize="20px" sx={{
                  textIndent: theme.spacing(6)
                }}>
                   &quot;@classranked.com&quot;
                  </Typography>
              </Box>
            </InstructionTypography>
            <InstructionTypography as="li">
              Find the survey for <strong>{sectionId}</strong> - <strong>{sectionTitle}</strong>
            </InstructionTypography>
          </Box>

          <FooterTypography>
            Need more help? Contact us at support@classranked.com
          </FooterTypography>
        </InstructionBox>

        <QrCodeSectionBox>
          <QrCodeTitle>Scan QR Code</QrCodeTitle>
          <QrCodeDescription>Scan this QR code to begin taking your survey.</QrCodeDescription>
          <QrCodeBox>
            <QRCode value={`${baseURL}/surveys/${distributionSeriesId}`} size={300} />
          </QrCodeBox>
        </QrCodeSectionBox>
      </Container>
    </>
  )
}

export default QrcodeFeature
